import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 94vh;
  background: #fcfcfc;
  padding: 25px 25px 50px 35px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
    background-color: #fcfcfc;
  }

  ::-webkit-scrollbar-thumb {
    background: #11a7d9;
    -webkit-border-radius: 1ex;
    -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
  }

  ::-webkit-scrollbar-corner {
    background: #11a7d9;
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  max-width: calc(1142px * 1.2);
  margin: 0 auto;
`;

export const BasicContainer = styled.div`
  max-width: calc(1142px * 1.2);
  margin: 0 auto;
  margin-bottom: 24px;
`;

export const BannerContainer = styled(BasicContainer)``;

export const OnGoingContainer = styled(BasicContainer)`
  padding: 24px;
`;

export const OnGoingContentContainer = styled.div`
  display: grid;
  gap: 16px;
`;

export const InProgressContainer = styled.div`
  width: 100%;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const InProgressSection = styled.section`
  width: 100%;
  background: linear-gradient(93.65deg, #002244 1.29%, #051a6c 130.28%);

  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
`;

export const InProgressContent = styled.div`
  font-family: "Poppins";
  color: #fff;
`;

export const InProgressText = styled(Link)`
  font-family: "Poppins";
  font-weight: 400;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #ffffff;
  margin-bottom: 0;
`;

export const SectionTitle = styled.h3`
  font-family: "Poppins";
  font-weight: 600;
  font-size: 22px;
  line-height: 40px;
  letter-spacing: 0%;
  margin-bottom: 0;
  color: #444444;
  margin-bottom: 16px;
`;

export const InProgressTitle = styled.p`
  font-family: "Poppins";
  font-weight: 700;
  font-size: 26px;
  /* line-height: 100%; */
  letter-spacing: 0%;
  margin-bottom: 0;
  color: #ffffff;
  width: 600px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InProgressLesson = styled.p`
  font-family: "Poppins";
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #ffffff;

  margin: 0;
  width: 600px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InProgressButton = styled(Link)`
  width: fit-content;
  padding: 1rem 1.5rem;
  background: #11a7d9;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 5px;
  text-transform: uppercase;

  &:hover {
    background: #11a7d9;
    color: #fff;
  }
`;

export const LoadingComponent = styled.div`
  position: absolute;
  z-index: 10;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.8);
`;
